// Query param to force-show the meetings page onboarding tour during QA/debug.
const SHOW_MEETINGS_TOUR_QUERY_PARAM = 'show_meetings_tour'

export const isMeetingsTourForceShownForTesting = () => (
  new URLSearchParams(window.location.search).get(SHOW_MEETINGS_TOUR_QUERY_PARAM) === '1'
)
